import { FAQPageJsonLd } from 'next-seo';
import { Accordion } from '@prishapolicy/shared/ui';

export const Faq = (props: Parameters<typeof Accordion>[0]) => {
  return (
    <div className="bg-white ">
      <div className="container grid-cols-3 py-16 xl:grid w-full">
        <div>
          <h2 className="heading-3">Questions You Might Have</h2>
        </div>
        <div className="col-span-2">
          <Accordion {...props} />
          <FAQPageJsonLd
            mainEntity={props.list.map((elem) => ({
              questionName: elem.question,
              acceptedAnswerText: elem.answer,
            }))}
          />
        </div>
      </div>
    </div>
  );
};

export default Faq;
